import React from 'react';

// import Fab from '@material-ui/core/Fab';
// import AddIcon from '@material-ui/icons/Add';
// import Icon from '@material-ui/core/Icon';
// import TelegramIcon from '@material-ui/icons/Telegram';
// import constants from '../constants';
import commonConstants from '../commonConstants';

class Contact extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showGuide: false,
    }
  }

  render() {
    // const styles = theme => ({
    //   root: {
    //     width: '100%',
    //     marginTop: theme.spacing.unit * 3,
    //     overflowX: 'auto',
    //   },
    //   fab: {
    //       position: "fixed",
    //       bottom: theme.spacing.unit * 2,
    //       right: theme.spacing.unit * 3
    //   },
    //   extendedIcon: {
    //     marginRight: theme.spacing.unit,
    //   },
    // });
    let position = 'fixed';
    if (this.props.inPlace && this.props.inPlace === true) {
      position = 'inherit';
    }

    const style = {
        margin: 0,
        top: 'auto',
        right: 20,
        bottom: 45,
        left: 'auto',
        position: position,
        backgroundColor: commonConstants.colors["--color-smart-main-surface"],
    };
    const astyle = {
      "color": "inherit",
      "textDecoration": "inherit",
    }

    return "";
  }

}

export default Contact;
